import React, { FC } from 'react';
import { Button, Layout, Dropdown, Menu} from 'antd';

import { connect } from 'react-redux';
import { MainReducerState } from '../store/reducers';

import { logout, getUser, CheckLoginStatusState } from '../store/actions/auth';

interface HeaderProps {
    onLogout: typeof logout.trigger;
    user: CheckLoginStatusState['user'];
}

const Header: FC<HeaderProps> = ({ onLogout, user }) => {
    const onMenuClick = (e: any) => {
        if (e.key === '2') {
            onLogout();
        }
    };
    const menu = (
        <Menu onClick={onMenuClick}>
            <Menu.Item disabled={true} key="1">
                {user && user.firstName + ' ' + user.lastName}
            </Menu.Item >
            <Menu.Item disabled={true} key="1.5" style={{marginLeft: 10}}>
                {user?.position + ' / ' + user?.role}
            </Menu.Item >
            <Menu.Item key="2">
                Déconnexion
            </Menu.Item>
        </Menu>
    );
    return (
        <Layout.Header id="main-header">
            <div id="logo-nav-wrapper">
                <div className="logo-wrapper">
                    <img
                        id="logo"
                        src={`${process.env.PUBLIC_URL}/images/logo-marionnaud-noir.png`}
                        alt="logo"
                    />
                </div>
            </div>
            <Dropdown overlay={menu} placement="bottomLeft">
                <Button shape="circle" icon="user" />
            </Dropdown>

        </Layout.Header>
    );
};
const mapStateToProps = (state: MainReducerState) => ({
    user: getUser(state),
});

export default connect(
    mapStateToProps,
    {
        onLogout: logout.trigger,
    },
)(Header);
